import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TCountOfItems, ISoftwareUpdates } from 'types';
import { AxiosResponse } from 'axios';

export type TPushesViewSortBy =
	| ''
	| 'Name1-10'
	| 'Name10-1'
	| 'LastUpdate1-10'
	| 'LastUpdate10-1'
	| 'UpdatedByA-Z'
	| 'UpdatedByZ-A'
	| 'SoftwareTypeA-Z'
	| 'SoftwareTypeZ-A';
export type TTypeOfModalWindow = null | 'success' | 'error' | 'confirm' | 'showAdditionalModal';

export interface IPushesViewState {
	softwareUpdates: ISoftwareUpdates;
	searchString: string;
	sortBy: TPushesViewSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	restaurantsForPush: string[];
	pushCallback: ((restaurantsForPush: string[]) => Promise<void>) | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const pushesViewInitialState: IPushesViewState = {
	softwareUpdates: { count: 0, items: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	fetchedRestaurants: [],
	restaurantsForPush: [],
	pushCallback: null,
	typeOfModalWindow: null,
};

export interface IPushesViewContext extends IPushesViewState {
	changeSearchString(value: string): void;
	setSortBy(sortBy: TPushesViewSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setFetchedRestaurants(value: IItemForGetShortInfoWithStatus[]): void;
	setRestaurantsForPush(value: string[]): void;
	setPushCallback(value: ((restaurantsForPush: string[]) => Promise<void>) | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const PushesViewContext = createContext<IPushesViewContext>({
	changeSearchString: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurantsForPush: () => undefined,
	setPushCallback: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...pushesViewInitialState,
});
